import React from "react";
import { withNamespaces } from "react-i18next";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

export function AlertModal({
  isOpen,
  heading,
  message,
  modalAction,
  shouldCancel,
  cancelModalAction,
  t,
}) {
  return (
    <Modal isOpen={isOpen} backdrop>
      <ModalHeader>{heading || ""}</ModalHeader>
      <ModalBody>
        <p>{message || ""}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="info" onClick={modalAction}>
          {t("dashboard.ok")}
        </Button>
        {shouldCancel && (
          <Button color="info" onClick={cancelModalAction}>
            {t("dashboard.cancel")}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default withNamespaces("translations")(AlertModal);
